window.addEventListener('load', function (event) {
    var socialMediaWrapperText = document.querySelector("#atstbx > .at4-visually-hidden");
    var socialMediaIconTexts = document.querySelectorAll("#atstbx .at-share-btn .at4-visually-hidden");

    if (document.querySelector("#atstbx") && socialMediaWrapperText.innerHTML.indexOf("AddThis") >= 0) {
        socialMediaWrapperText.innerText = "Social Sharing Buttons";

        for (i = 0; i < socialMediaIconTexts.length; i++) {
            socialMediaIconTexts[i].innerText = "Share to";
        }
    }
});